import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { createStructuredSelector } from 'reselect';
import Offers from 'routes/DateSelection/components/Offers';
import withPatronRewardsData from '../components/withPatronRewardsData';
import { setAdminSelectedOffers } from 'routes/DateSelection/reducer';
import {
  endDateSelector,
  propertySelector,
  startDateSelector,
  accountNumberSelector,
  submittedAccountSelector,
  isAdminSelector,
  isWaitListBookingSelector,
  adminSelectedOffersSelector
} from 'routes/DateSelection/selectors';
import { bookingSourceSelector } from 'routes/selectors';

const mapStateToProps = createStructuredSelector({
  startDate: startDateSelector,
  endDate: endDateSelector,
  property: propertySelector,
  accountNumber: accountNumberSelector,
  submittedAccount: submittedAccountSelector,
  isAdmin: isAdminSelector,
  bookingSource: bookingSourceSelector,
  isWaitListBooking: isWaitListBookingSelector,
  adminSelectedOffers: adminSelectedOffersSelector
});

function mapDispatchToProps(dispatch) {
  return {
    setAdminSelectedOffers: adminSelectedOffers =>
      dispatch(setAdminSelectedOffers(adminSelectedOffers))
  };
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withPatronRewardsData
)(Offers);
